// extracted by mini-css-extract-plugin
export default {"ProfilePhoto":"Viewstudentdetails_ProfilePhoto__8B1aw"};